import React, { useState } from 'react';
import Keycloak from 'keycloak-js';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { useDidMount } from '../../customHooks';
import { login, logout } from '../../redux_toolkit/loginSlice';
// import UserInfo from './UserInfo';
import { requestManager } from '../../requestManager';

// FIXME: コンフィグから取得するように変更すること
import { KC_URL, KC_REALM, KC_CLIENT_ID } from '../../config/config';

/**
 * ログインページ
 * @return {Object} -ログインページ
 */
const Login = function () {
  const navigate = useNavigate();
  const params = useParams();

  const [keycloak, setKeycloak] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);

  const dispatch = useDispatch();

  // 一度目の描画終了時に実行される
  useDidMount(() => {
    // const keycloak = Keycloak(`${process.env.PUBLIC_URL}/keycloak.json`);
    // eslint-disable-next-line new-cap
    const keycloak = Keycloak({ url: KC_URL, realm: KC_REALM, clientId: KC_CLIENT_ID });
    dispatch(logout());

    keycloak
      .init({
        promiseType: 'native',
      })
      .then((authenticated) => {
        if (authenticated) {
          const { token = '', refreshToken = '' } = keycloak;
          requestManager.setKeycloak(keycloak);
          dispatch(
            login({
              accessToken: token,
              refreshToken,
            })
          );
          setKeycloak(keycloak);
          setAuthenticated(authenticated);
          navigate(`/${params.lgCd}`);
        } else {
          keycloak
            .login({ scope: 'openid' })
            .then((authenticated) => {
              const { token = '', refreshToken = '' } = keycloak;
              requestManager.setKeycloak(keycloak);
              dispatch(
                login({
                  accessToken: token,
                  refreshToken,
                })
              );
              setKeycloak(keycloak);
              setAuthenticated(authenticated);
              // navigate(`/syokuin/${params.lgCd}`);
              navigate(`/${params.lgCd}`);
            })
            .catch(() => {
              window.alert('ログインに失敗しました。再度ログインしてください。');
              navigate(`/syokuin/login/${params.lgCd}`);
            });
        }
      })
      .catch(() => {
        window.alert('認証情報の初期化に失敗しました。');
        navigate(`/syokuin/login/${params.lgCd}`);
      });
  });

  if (keycloak) {
    if (authenticated) {
      // return (
      //   <div>
      //     <UserInfo keycloak={keycloak} />
      //   </div>
      // );
      return null;
    }
    return <div>ログインに失敗しました。</div>;
  }
  return <div>ログインしています...</div>;
};

export default Login;
